import { DiagnosisInclusion } from './diagnosis-inclusion.mode';

export class PatientHealthResponse {
  allergies: number[];
  diagnoses: DiagnosisInclusion[];
}
